.drawer_title {
  height: 50px;
  background: #38468c 100%;
}
.drawer_title.god {
  background-color: #cc0000;
}

.drawer_title b {
  display: block;
  padding-top: 16px;
  margin-left: 32px;
  margin-bottom: 8px;
  color: white;
  opacity: 0.7;
  font-family: var(--vrf-font-family);
  font-size: 12px;
  height: 16px;
  align-items: center;
}

.drawer_content {
  height: calc(100vh - 50px);
  overflow-x: hidden;
  overflow-y: scroll;
}

.drawer_content .item {
  position: relative;
  cursor: pointer;
}

.drawer_content .item > *:hover,
.drawer_content .item > div.accordin > .accordin_item:hover {
  background: #38468c;
}

.drawer_content .item > div {
  display: flex;
  color: #fff;
  flex-direction: row;
  padding: 8px 16px;
  align-items: center;
}

.drawer_content .item > div > * {
  cursor: pointer;
}

.drawer_content .item > div:first-child > link {
  flex: 1;
  padding: 0 10px;
}

.drawer_content .item > div.accordin {
  flex-direction: column;
  background: #131313;
  height: 100%;
  align-items: flex-start;
  display: none;
}

.drawer_content .item > div.accordin {
  display: flex;
  padding: 0;
}

.drawer-header {
  background: #282828;
}

.drawer_content .item > div.accordin > .accordin_item {
  padding: 13px 16px 13px 50px;
  color: #fff;
  text-decoration: none;
  width: 100%;
}

.drawer vaadin-tabs {
  overflow: hidden;
  height: 100%;
  color: white;
  background: #38468c 100%;
  font-family: var(--vrf-font-family);
  margin: 0 auto;
  flex: 1;
}

.drawer vaadin-tabs vaadin-tab {
  width: 400px;
  padding-left: 32px;
  height: 40px;
  font-size: 14px;
  font-family: var(--vrf-font-family);
  color: white;
}

.drawer vaadin-tab[selected] {
  background-color: #5b68d2;
}

.drawer vaadin-tab:hover:not([selected]) {
  opacity: 0.5;
}
